import React from 'react';
import { Body, Label, Link as SatoLink } from '@sato/components';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { ServiceParty } from '@models/realEstate.types';
import { localizationStore } from '@stores/localization';

import { ExternalLink } from './Link';

interface ServicePartyInfoProps {
  serviceParty?: ServiceParty;
  className?: string;
}

const ServicePartyInfo = observer(
  ({ serviceParty, className }: ServicePartyInfoProps) => {
    if (!serviceParty) return null;

    const {
      name,
      email,
      phone,
      city,
      postalCode,
      webSiteUrl,
      serviceOpenHours,
      addressLine1,
    } = serviceParty;

    const t = localizationStore.getTranslation;

    return (
      <div className={classNames('flex flex-col gap-2', className)}>
        <Label component="span">{name}</Label>

        <Body>
          {addressLine1} <br />
          {postalCode} {city}
        </Body>

        <Body>
          {t('customer_service_title')}:{' '}
          <SatoLink href={`tel:${phone}`}>{phone}</SatoLink>
        </Body>

        {email && <SatoLink href={`mailto:${email}`}>{email}</SatoLink>}

        {serviceOpenHours && (
          <>
            <Body>{t('customer_service_open_hours')}</Body>
            <Body>{serviceOpenHours}</Body>
          </>
        )}

        {webSiteUrl && (
          <SatoLink href={webSiteUrl} wrapperComponent={ExternalLink}>
            {webSiteUrl}
          </SatoLink>
        )}
      </div>
    );
  }
);

export default ServicePartyInfo;
